import { service } from "@/api/service ";
import { toast, toastError } from "@/components/custom/Toast";
import store from "../..";

const state = {
  empShifts: [],
  empShift: [],
  addStatus: false,
  deleteStatus: false,
  editStatus: false,
  pagination: {},
};
const getters = {
  empShiftListGet: (state) => state.empShifts,
  empShiftGet: (state) => state.empShifts,
  paginationGet: (state) => state.pagination,
};
const actions = {
  getEmpShifts({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    service.getFun(`empShifts?page=${page}`).then(
      (obj) => {
        var result = obj.data.empShifts;
        const pageResult = {
          currentPage: obj.data.current_page,
          lastPage: obj.data.last_page,
          itemsPerPage: obj.data.per_page,
          total: obj.data.total,
        };
        commit("empShiftListSet", result);
        commit("setPagination", pageResult);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  getEmpShiftById({ commit }, payload) {
    service.getFun(`show-employees_by_shift/${payload.id}`).then(
      (obj) => {
        var result = obj.data;
        commit("getEmpShiftById", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  addEmpShift({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `add-employees-to-shift`,
        null,
        {
          action: "getEmpShiftById",
          page: store.state.page.page,
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("addEmpShiftStatus", result.success);
            toast(result.message);
          } else {
            commit("addEmpShiftStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  editEmpShift({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `empShifts/edit/${payload.id}`,
        null,
        {
          action: "getEmpShiftById",
          page: store.state.page.page,
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("editEmpShiftStatus", result.success);
            toast(result.message);
          } else {
            commit("editEmpShiftStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deleteEmpShift({ commit }, payload) {
    service
      .postFun(
        {
          shift_id: payload.shiftId,
          employee_id: payload.payload,
          SHIFTID: payload.SHIFTID,
        },
        `remove-employees-from-shift`,
        null,
        {
          action: "getEmpShiftById",
          page: store.state.page.page,
        }
      )
      .then(
        (result) => {
          if (result) {
            commit("deleteEmpShiftStatus", result.success);
            toast(result.message);
          } else {
            commit("deleteEmpShiftStatus", false);
          }
        },
        (error) => {
          toastError(error);
        }
      );
  },
};
const mutations = {
  empShiftListSet(state, empShifts) {
    state.empShifts = empShifts;
  },
  addEmpShiftStatus(state, Status) {
    state.addStatus = Status;
  },
  getEmpShiftById(state, empShift) {
    state.empShifts = empShift;
  },
  editEmpShiftStatus(state, Status) {
    state.editStatus = Status;
  },
  deleteEmpShiftStatus(state, Status) {
    state.deleteStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
